import { LogoIcon } from "../../assets/imageAssets";
import Input from "../../components/Input";
import Button from "../../components/Buttons/button";
import TextButton from "../../components/Buttons/textButton";
import CheckboxLabel from "../../components/CheckboxLabel";
import { openModals, closeModal } from "../../redux/modal.slice";
import ModalsEnum from "../../enums/modal.enum";
import { useDispatch } from "react-redux";

import { currentUser_req, signIn_req } from "../../api/user.api";
import { topicAnswered_req } from "../../api/profiles.api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setMeData, setAnswersData } from "../../redux/me.slice";
import { getPendingSurvey, clearPendingSurvey } from "../../utils/pendingSurvey";
import { setAuthToken } from "../../utils/authToken";

const SignInModal = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [error, setError] = useState("");
  const [state, setState] = useState({ email: "", password: "" });
  const [checked, setChecked] = useState(false);

  const handleSignUp = () => {
    dispatch(closeModal({}));
    dispatch(
      openModals({
        modalIds: [ModalsEnum.SIGN_UP_MODAL],
      })
    );
  };

  const handleResetPassword = () => {
    dispatch(closeModal({}));
    dispatch(
      openModals({
        modalIds: [ModalsEnum.RESET_PASSWORD_MODAL],
        modalData: [
          {
            className: "reset-password-modal",
          },
        ],
      })
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const signIn = async () => {
    try {
      const response = await signIn_req(state);

      const token = response.headers["authorization"];
      setAuthToken(token, { rememberMe: checked });

      const responseData = await currentUser_req();
      setError(null);

      dispatch(setMeData(responseData?.user));
      dispatch(closeModal({}));

      const pendingSurvey = getPendingSurvey();

      if (pendingSurvey) {
        try {
          const reportResponse = await topicAnswered_req(pendingSurvey.profileId, pendingSurvey.topicId, pendingSurvey.answers);

          clearPendingSurvey();
          dispatch(setAnswersData(null));

          navigation(`/report/${pendingSurvey.profileId}?topic=${pendingSurvey.topicId}`, {
            state: { data: reportResponse },
          });
          return;
        } catch (reportError) {
          console.log("reportError", reportError);
          clearPendingSurvey();
          dispatch(setAnswersData(null));

          navigation(`/profiles/${pendingSurvey.profileId}/topics/${pendingSurvey.topicId}/questions`);
          return;
        }
      }

      navigation("/");
    } catch (e) {
      console.log("e", e);
      setError(e?.response?.data?.error);
    }
  };
  const closePopup = () => {
    dispatch(closeModal({}));
  };
  const handleChangeCheck = () => {
    setChecked(!checked);
  };

  return (
    <>
      <div className="modal-header">
        <div className="modal-title flex flex-align-center mb-16">
          <img
            src={LogoIcon}
            alt="Logo"
          />
          <h4>Log in to your account</h4>
        </div>
        <p className="medium-text text-color-grey">
          Welcome back! Please enter your details.
        </p>
      </div>
      <div className="modal-body">
        <p className="have-account-question medium-text text-color-grey-700 mb-20">
          Don’t have an account?
          <TextButton
            text={"Sign Up"}
            className={"ml-8"}
            onClick={handleSignUp}
          />
        </p>

        <form>
          <Input
            id={"email"}
            label={"Email"}
            placeholder={"Enter your email"}
            name={"email"}
            onChange={handleChange}
            type={"email"}
            className="mb-16"
            // error={error ? true : false}
            // errorMessage={error}
          />
          <Input
            id={"password"}
            label={"Password"}
            placeholder={"Enter your password"}
            onChange={handleChange}
            name={"password"}
            type={"password"}
            className="mb-20"
            error={error ? true : false}
            errorMessage={error}
          />
        </form>

        <div className="flex flex-align-center flex-between">
          <CheckboxLabel
            text={"Remember me"}
            id={"remember-check"}
            checked={checked}
            onChange={handleChangeCheck}
          />
          <TextButton
            text={"Forgot password"}
            size={"small"}
            onClick={handleResetPassword}
          />
        </div>
      </div>
      <div className="modal-footer flex flex-align-center">
        <Button
          text={"Cancel"}
          type={"outline"}
          className={"mr-16"}
          fullWidth={true}
          onClick={closePopup}
        />
        <Button
          text={"Sign In"}
          fullWidth={true}
          onClick={signIn}
        />
      </div>
    </>
  );
};

export default SignInModal;
